import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { DataAdministrationService } from '../../data-administration/services/data-administration-service';

@Component({
  selector: 'app-characteristic-specification',
  templateUrl: './characteristic-specification.component.html',
  styleUrls: ['./characteristic-specification.component.scss']
})
export class CharacteristicSpecificationComponent implements OnInit {

	@Input() fieldName: string;
	@Input() hostEntity: Object;
	@Input() entityType: string;
	@Input() mode: string = 'create';
	@Input() characteristicSpecificationId: string;
	characteristics = [];
	units = [];
	loading: boolean = true;
	entityType_single_translated: string;
	characteristicSpecification: Object = {};
	selectedCharacteristic: Object = {};
	buttonLocked: boolean = false;

	constructor(private dataAdministrationService: DataAdministrationService, public activeModal: NgbActiveModal, private toastManager: ToastrService, private translate: TranslateService) { }

	ngOnInit() {
		console.log(this.hostEntity);
		var self = this;
		this.translate.get('data_administration.entities.characteristicSpecification.single').subscribe((res: string) => { this.entityType_single_translated = res; });
		
		this.dataAdministrationService.loadAllCandidates('App\\Entity\\Characteristic', 'characteristic', this.entityType).subscribe(characteristics => {
			this.characteristics = characteristics;
			if (this.characteristicSpecificationId) {
				this.dataAdministrationService.getEntity('administration', 'characteristicSpecification', this.characteristicSpecificationId).subscribe(response => {
					Object.keys(response).forEach(function(key) {
						var value = response[key];
						if (key === 'value' && value === 'false') {
							value = false;
						}
						if (typeof value === 'object' && value !== null) {
							self.characteristicSpecification[key] = value['id'];
						} else {
							self.characteristicSpecification[key] = value;
						}
					});
	
					this.selectedCharacteristic = this.characteristics.filter(characteristic => characteristic['id'] === this.characteristicSpecification['characteristic'])[0];
					if (this.selectedCharacteristic['data_type'] === 'value_range') {
						let parts = this.characteristicSpecification['value'].split('-');
						this.characteristicSpecification['value_min'] = parts[0];
						this.characteristicSpecification['value_max'] = parts[1];
					}

					this.selectedCharacteristic['allowed_values'].sort();
					this.loading = false;
				}, err => {
					this.loading = false;
					this.translate.get('data_administration.errors.load_form').subscribe((res: string) => {
						this.toastManager.error(res);
						this.activeModal.close();
					});
				});
			} else {
				this.loading = false;
			}
		}, err => {
			this.loading = false;
			this.translate.get('data_administration.errors.load_form').subscribe((res: string) => {
				this.toastManager.error(res);
				this.activeModal.close();
			});
		});

		this.dataAdministrationService.loadAllCandidates('App\\Entity\\Unit', 'unit').subscribe(units => {
			this.units = units;
		}, err => {
			this.translate.get('data_administration.errors.load_form').subscribe((res: string) => {
				this.toastManager.error(res);
				this.activeModal.close();
			});
		});
	}

	onChangeCharacteristic(characteristicId) {
		this.selectedCharacteristic = this.characteristics.filter(characteristic => characteristic['id'] === characteristicId)[0];
		this.selectedCharacteristic['allowed_values'].sort();
		if (this.selectedCharacteristic['data_type'] === 'boolean') this.characteristicSpecification['value'] = true;
		else this.characteristicSpecification['value'] = null;
		this.characteristicSpecification['unit'] = this.selectedCharacteristic['unit'];
	}

	saveEntity() {
		this.buttonLocked = true;
		var valueDataType = 'string';
		if (this.selectedCharacteristic['data_type'] === 'datetime') valueDataType = 'datetime';

		if (this.selectedCharacteristic['data_type'] === 'value_range') {
			this.characteristicSpecification['value'] = this.characteristicSpecification['value_min'] + '-' + this.characteristicSpecification['value_max'];
			delete this.characteristicSpecification['value_min'];
			delete this.characteristicSpecification['value_max'];
		}

		if (this.mode === 'create') {
			this.dataAdministrationService.createEntity('administration', 'characteristicSpecification', this.characteristicSpecification, [{'snake_case': 'characteristic', 'data_type': 'string'}, {'snake_case': 'value', 'data_type': valueDataType}, {'snake_case': 'unit', 'data_type': 'string'}]).subscribe(
				response => {
					console.log(this.hostEntity);
					console.log('add characteristic');
					this.translate.get('data_administration.success.create',  {entityType: this.entityType_single_translated})
						.subscribe((res: string) => {
							this.toastManager.success(res);
							this.activeModal.close();
							if (this.hostEntity[this.fieldName]) this.hostEntity[this.fieldName].push({'value': response['id'], 'display': response['characteristic']['name']});
							else this.hostEntity[this.fieldName] = [{'value': response['id'], 'display': response['characteristic']['name']}];
						});
				}, err => {
					this.buttonLocked = false;
				this.translate.get('data_administration.errors.create',  {entityType: this.entityType_single_translated})
					.subscribe((res: string) => { this.toastManager.error(res); });  
			});
		} else {
			this.dataAdministrationService.updateEntity('administration', 'characteristicSpecification', this.characteristicSpecification, [{'snake_case': 'characteristic', 'data_type': 'string'}, {'snake_case': 'value', 'data_type': valueDataType}, {'snake_case': 'unit', 'data_type': 'string'}]).subscribe(
				response => {
					this.translate.get('data_administration.success.update',  {entityType: this.entityType_single_translated})
						.subscribe((res: string) => {
							this.toastManager.success(res);
							this.activeModal.close();
						}); 
				}, err => {
					this.buttonLocked = false;
					this.translate.get('data_administration.errors.update',  {entityType: this.entityType_single_translated})
						.subscribe((res: string) => { this.toastManager.error(res); }); 
				});
		}
	}

	cancel() {
		this.activeModal.close();
	}
}
